import { generatePath } from 'react-router'

import {
  INVENTORY_SETTINGS,
  MANAGE_PERMISSIONS,
  ORDER_SETTINGS,
  PAYMENT_SETTINGS,
  PERMISSIONS_SETTINGS,
  STYLE_SETTINGS,
  USER_MANAGEMENT,
} from 'routes/paths'

import DropdownMenuTextLink from '../../DropdownMenuTextLink/DropdownMenuTextLink'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { SettingsDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'

const BrandSettings = ({
  isBrandAccount,
  restrictEditStyles,
  allowManagePayments,
  brandPaymentsSettings,
  canTransact,
  canManagePermissions,
  canViewPermissions,
  allowEditInventorySettings,
  isLiteBrandAccount,
  canSeeUserManagement,
  newPermissionsPage,
}: {
  isBrandAccount: boolean
  restrictEditStyles: boolean
  allowManagePayments: boolean
  brandPaymentsSettings: boolean
  canTransact: boolean
  canManagePermissions: boolean
  canViewPermissions: boolean
  allowEditInventorySettings: boolean
  isLiteBrandAccount: boolean
  canSeeUserManagement: boolean
  newPermissionsPage: boolean
}) =>
  isBrandAccount ? (
    <>
      {!restrictEditStyles && (
        <DropdownMenuTextLink
          to={STYLE_SETTINGS}
          message={messages.styleSettings}
          id={SettingsDropdownIds.SettingsOptionStyleSettings}
        />
      )}
      {brandPaymentsSettings && allowManagePayments && (
        <DropdownMenuTextLink
          to={PAYMENT_SETTINGS}
          message={messages.paymentSettings}
          id={SettingsDropdownIds.SettingsOptionPayment}
        />
      )}
      {canTransact && (
        <DropdownMenuTextLink
          to={ORDER_SETTINGS}
          message={messages.ordersSettings}
          id={SettingsDropdownIds.SettingsOptionOrderSettings}
        />
      )}
      {!isLiteBrandAccount && canViewPermissions && (
        <DropdownMenuTextLink
          to={
            canManagePermissions && newPermissionsPage
              ? MANAGE_PERMISSIONS
              : generatePath(PERMISSIONS_SETTINGS, { userId: null })
          }
          message={messages.permissionSettings}
          id={SettingsDropdownIds.SettingsOptionPermissions}
        />
      )}
      {canSeeUserManagement && (
        <DropdownMenuTextLink
          to={USER_MANAGEMENT}
          message={messages.userManagement}
          id={SettingsDropdownIds.SettingsOptionUserManagement}
        />
      )}
      {allowEditInventorySettings && !isLiteBrandAccount && (
        <DropdownMenuTextLink
          to={INVENTORY_SETTINGS}
          message={messages.inventorySettings}
          id={SettingsDropdownIds.SettingsOptionInventory}
        />
      )}
    </>
  ) : null

export default BrandSettings
